import React from "react";
import PropTypes from "prop-types";

const MissingOrder = props => (
  <div xs={12} style={{ textAlign: "center" }}>
    <h1>I'm sorry but there has been a problem, we can't find your order.</h1>
    <h2>
      Please{" "}
      <a href={`https://support.${props.brandName}.co.uk/support/tickets/new`}>
        get in touch
      </a>{" "}
      with our team so that it can be swiftly resolved.
    </h2>
  </div>
);

MissingOrder.propTypes = {
  brandName: PropTypes.string
};

export default MissingOrder;
